module.exports = __webpack_public_path__ + "static/media/alerta.d0df4ce1.png";